module.exports = {
      id: "sort-usage",
      viewBox: "0 0 6 8",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#sort",
      toString: function () {
        return this.url;
      }
    }